// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type OptionsLegacyParser,
  formDataBodySerializer,
} from '@hey-api/client-fetch';
import type {
  HealthCheckError,
  HealthCheckResponse,
  CreateEnterpriseContactFormData,
  CreateEnterpriseContactFormError,
  CreateEnterpriseContactFormResponse,
  GetTimezonesError,
  GetTimezonesResponse,
  GetCurrentUserError,
  GetCurrentUserResponse,
  ListCountriesError,
  ListCountriesResponse,
  UpdateUserDetailsData,
  UpdateUserDetailsError,
  UpdateUserDetailsResponse,
  GetPaymentMethodUrlError,
  GetPaymentMethodUrlResponse,
  GetBillingInformationError,
  GetBillingInformationResponse,
  GetUserProfileError,
  GetUserProfileResponse,
  CheckUsernameAvailabilityData,
  CheckUsernameAvailabilityError,
  CheckUsernameAvailabilityResponse,
  CreateAddressData,
  CreateAddressError,
  CreateAddressResponse,
  ListOrganisationsError,
  ListOrganisationsResponse,
  GetOrganisationDetailsError,
  GetOrganisationDetailsResponse,
  UpdateOrganisationDetailsData,
  UpdateOrganisationDetailsError,
  UpdateOrganisationDetailsResponse,
  GetOrganisationUserOnboardingDetailsError,
  GetOrganisationUserOnboardingDetailsResponse,
  UpdateOrganisationAddressData,
  UpdateOrganisationAddressError,
  UpdateOrganisationAddressResponse,
  GetOrganisationMembersError,
  GetOrganisationMembersResponse,
  InviteUserToOrganisationData,
  InviteUserToOrganisationError,
  InviteUserToOrganisationResponse,
  ListInvitesForUserError,
  ListInvitesForUserResponse,
  RespondToOrganisationInviteData,
  RespondToOrganisationInviteError,
  RespondToOrganisationInviteResponse,
  ListOrganisationInvitesError,
  ListOrganisationInvitesResponse,
  CancelOrganisationInviteData,
  CancelOrganisationInviteError,
  CancelOrganisationInviteResponse,
  ExtendOrganisationInviteData,
  ExtendOrganisationInviteError,
  ExtendOrganisationInviteResponse,
  GetCalendarsError,
  GetCalendarsResponse,
  SetCalendarForEventsData,
  SetCalendarForEventsError,
  SetCalendarForEventsResponse,
  GetEventsCalendarError,
  GetEventsCalendarResponse,
  GetSchedulesError,
  GetSchedulesResponse,
  CreateScheduleData,
  CreateScheduleError,
  CreateScheduleResponse,
  GetDefaultScheduleError,
  GetDefaultScheduleResponse,
  CheckScheduleOverlapsData,
  CheckScheduleOverlapsError,
  CheckScheduleOverlapsResponse,
  GetScheduleData,
  GetScheduleError,
  GetScheduleResponse,
  UpdateScheduleData,
  UpdateScheduleError,
  UpdateScheduleResponse,
  DeleteScheduleData,
  DeleteScheduleError,
  DeleteScheduleResponse,
  SetDefaultScheduleData,
  SetDefaultScheduleError,
  SetDefaultScheduleResponse,
  DuplicateScheduleData,
  DuplicateScheduleError,
  DuplicateScheduleResponse,
  SyncEventsForCalendarData,
  SyncEventsForCalendarError,
  SyncEventsForCalendarResponse,
  CreateEventTypeData,
  CreateEventTypeError,
  CreateEventTypeResponse,
  GetEventTypesData,
  GetEventTypesError,
  GetEventTypesResponse,
  GetEventTypeByIdData,
  GetEventTypeByIdError,
  GetEventTypeByIdResponse,
  UpdateEventTypeData,
  UpdateEventTypeError,
  UpdateEventTypeResponse,
  DeleteEventTypeData,
  DeleteEventTypeError,
  DeleteEventTypeResponse,
  GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostData,
  GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostError,
  GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostResponse,
  GetTimeSlotsData,
  GetTimeSlotsError,
  GetTimeSlotsResponse,
  CreateBookingData,
  CreateBookingError,
  CreateBookingResponse,
  GetUserBookingsData,
  GetUserBookingsError,
  GetUserBookingsResponse,
  GetBookingByIdData,
  GetBookingByIdError,
  GetBookingByIdResponse,
  CancelBookingData,
  CancelBookingError,
  CancelBookingResponse,
  UpdateBookingStatusData,
  UpdateBookingStatusError,
  UpdateBookingStatusResponse,
  RescheduleBookingData,
  RescheduleBookingError,
  RescheduleBookingResponse,
  CreateDoctorBookingData,
  CreateDoctorBookingError,
  CreateDoctorBookingResponse,
  GetNextQuestionnaireQuestionData,
  GetNextQuestionnaireQuestionError,
  GetNextQuestionnaireQuestionResponse,
  SavePatientQuestionnaireResponseData,
  SavePatientQuestionnaireResponseError,
  SavePatientQuestionnaireResponseResponse,
  GetQuestionnaireResponsesData,
  GetQuestionnaireResponsesError,
  GetQuestionnaireResponsesResponse,
  GetStructuredQuestionnaireQuestionData,
  GetStructuredQuestionnaireQuestionError,
  GetStructuredQuestionnaireQuestionResponse,
  UploadAppointmentRecordingData,
  UploadAppointmentRecordingError,
  UploadAppointmentRecordingResponse,
  GetAppointmentRecordingsData,
  GetAppointmentRecordingsError,
  GetAppointmentRecordingsResponse,
  GetAppointmentRecordingData,
  GetAppointmentRecordingError,
  GetAppointmentRecordingResponse,
  UpdateAppointmentTimingData,
  UpdateAppointmentTimingError,
  UpdateAppointmentTimingResponse,
  GetRecordingStatusData,
  GetRecordingStatusError,
  GetRecordingStatusResponse,
  GetDetailedBookingData,
  GetDetailedBookingError,
  GetDetailedBookingResponse,
  GetBillingPlansError,
  GetBillingPlansResponse,
  GetBillingPlanData,
  GetBillingPlanError,
  GetBillingPlanResponse,
  GetOrganisationBillingPlanError,
  GetOrganisationBillingPlanResponse,
  UpgradeBillingPlanData,
  UpgradeBillingPlanError,
  UpgradeBillingPlanResponse,
  CreatePatientData,
  CreatePatientError,
  CreatePatientResponse,
  GetPatientsError,
  GetPatientsResponse,
  GetPatientData,
  GetPatientError,
  GetPatientResponse,
  UpdatePatientData,
  UpdatePatientError,
  UpdatePatientResponse,
  DeletePatientData,
  DeletePatientError,
  DeletePatientResponse,
  CreatePatientProfileData,
  CreatePatientProfileError,
  CreatePatientProfileResponse,
  UpdatePatientProfileData,
  UpdatePatientProfileError,
  UpdatePatientProfileResponse,
  CreatePatientVitalData,
  CreatePatientVitalError,
  CreatePatientVitalResponse,
  GetPatientVitalsData,
  GetPatientVitalsError,
  GetPatientVitalsResponse,
  CreatePatientMedicationData,
  CreatePatientMedicationError,
  CreatePatientMedicationResponse,
  GetPatientMedicationsData,
  GetPatientMedicationsError,
  GetPatientMedicationsResponse,
  CreatePatientAllergyData,
  CreatePatientAllergyError,
  CreatePatientAllergyResponse,
  GetPatientAllergiesData,
  GetPatientAllergiesError,
  GetPatientAllergiesResponse,
  CreatePatientVisitData,
  CreatePatientVisitError,
  CreatePatientVisitResponse,
  GetPatientVisitsData,
  GetPatientVisitsError,
  GetPatientVisitsResponse,
  GetPatientVisitData,
  GetPatientVisitError,
  GetPatientVisitResponse,
  GetPatientsByDoctorData,
  GetPatientsByDoctorError,
  GetPatientsByDoctorResponse,
  GetPatientsCreatedByUserData,
  GetPatientsCreatedByUserError,
  GetPatientsCreatedByUserResponse,
  GetMyPatientsError,
  GetMyPatientsResponse,
  VerifyPatientOnboardingTokenData,
  VerifyPatientOnboardingTokenError,
  VerifyPatientOnboardingTokenResponse,
  SubmitPatientOnboardingData,
  SubmitPatientOnboardingError,
  SubmitPatientOnboardingResponse,
  SendPatientOnboardingData,
  SendPatientOnboardingError,
  SendPatientOnboardingResponse,
  SubmitPatientSelfEditData,
  SubmitPatientSelfEditError,
  SubmitPatientSelfEditResponse,
  VerifyPatientSelfEditTokenData,
  VerifyPatientSelfEditTokenError,
  VerifyPatientSelfEditTokenResponse,
  SendPatientSelfEditData,
  SendPatientSelfEditError,
  SendPatientSelfEditResponse,
} from './types.gen';

export const client = createClient(createConfig());

/**
 * Health Check
 * Checks the health of whisperer - lol.
 *
 * It returns 200 if whisperer is healthy. whisperer is always healthy.
 */
export const healthCheck = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    HealthCheckResponse,
    HealthCheckError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/health',
  });
};

/**
 * Create Enterprise Contact Form
 */
export const createEnterpriseContactForm = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<CreateEnterpriseContactFormData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateEnterpriseContactFormResponse,
    CreateEnterpriseContactFormError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/enterprise-contact-form',
  });
};

/**
 * Get Timezones
 */
export const getTimezones = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetTimezonesResponse,
    GetTimezonesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/timezones',
  });
};

/**
 * Whoami
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCurrentUserResponse,
    GetCurrentUserError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/whoami',
  });
};

/**
 * Get Countries
 * Get list of countries.
 */
export const listCountries = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListCountriesResponse,
    ListCountriesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/countries',
  });
};

/**
 * Update User
 * Update user details.
 */
export const updateUserDetails = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateUserDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateUserDetailsResponse,
    UpdateUserDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/me',
  });
};

/**
 * Add Payment Method
 * Get Stripe Checkout URL to add a payment method.
 */
export const getPaymentMethodUrl = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPaymentMethodUrlResponse,
    GetPaymentMethodUrlError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/add-payment-method',
  });
};

/**
 * Get Billing Information
 * Get organization's payment methods.
 */
export const getBillingInformation = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBillingInformationResponse,
    GetBillingInformationError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/billing-information',
  });
};

/**
 * Get User Profile
 * Get user profile.
 */
export const getUserProfile = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUserProfileResponse,
    GetUserProfileError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/profile',
  });
};

/**
 * Check Username Availability
 * Check if a username is available.
 */
export const checkUsernameAvailability = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CheckUsernameAvailabilityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    CheckUsernameAvailabilityResponse,
    CheckUsernameAvailabilityError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/username-available',
  });
};

/**
 * Create Address
 * Create address.
 */
export const createAddress = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateAddressData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateAddressResponse,
    CreateAddressError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/user/address',
  });
};

/**
 * Get Organisations List
 */
export const listOrganisations = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListOrganisationsResponse,
    ListOrganisationsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/list',
  });
};

/**
 * Get Organisation Details
 */
export const getOrganisationDetails = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganisationDetailsResponse,
    GetOrganisationDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/details',
  });
};

/**
 * Update Organisation Details
 * Update organisation details.
 */
export const updateOrganisationDetails = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateOrganisationDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOrganisationDetailsResponse,
    UpdateOrganisationDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/details',
  });
};

/**
 * Get Organisation User Onboarding Details
 */
export const getOrganisationUserOnboardingDetails = <
  ThrowOnError extends boolean = false
>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganisationUserOnboardingDetailsResponse,
    GetOrganisationUserOnboardingDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/onboarding-details',
  });
};

/**
 * Update Organisation Address
 */
export const updateOrganisationAddress = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateOrganisationAddressData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOrganisationAddressResponse,
    UpdateOrganisationAddressError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/address',
  });
};

/**
 * Get Organisation Members
 */
export const getOrganisationMembers = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganisationMembersResponse,
    GetOrganisationMembersError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/members',
  });
};

/**
 * Invite User To Organisation
 */
export const inviteUserToOrganisation = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<InviteUserToOrganisationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    InviteUserToOrganisationResponse,
    InviteUserToOrganisationError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/invite',
  });
};

/**
 * List Invites For User
 */
export const listInvitesForUser = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListInvitesForUserResponse,
    ListInvitesForUserError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/invites',
  });
};

/**
 * Respond To Organisation Invite
 */
export const respondToOrganisationInvite = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<RespondToOrganisationInviteData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    RespondToOrganisationInviteResponse,
    RespondToOrganisationInviteError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/invite/respond/{invite_id}',
  });
};

/**
 * List Organisation Invites
 * List all pending invites for an organisation (admin only).
 */
export const listOrganisationInvites = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListOrganisationInvitesResponse,
    ListOrganisationInvitesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/admin/invites',
  });
};

/**
 * Cancel Organisation Invite
 * Cancel an organisation invite (admin only).
 */
export const cancelOrganisationInvite = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CancelOrganisationInviteData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    CancelOrganisationInviteResponse,
    CancelOrganisationInviteError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/admin/invite/{invite_id}',
  });
};

/**
 * Extend Organisation Invite
 * Extend an invitation's expiration time and resend the email (admin only).
 */
export const extendOrganisationInvite = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<ExtendOrganisationInviteData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ExtendOrganisationInviteResponse,
    ExtendOrganisationInviteError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/organisation/admin/invite/{invite_id}/extend',
  });
};

/**
 * Get Calendars
 * Get all calendars for the current user.
 */
export const getCalendars = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCalendarsResponse,
    GetCalendarsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar',
  });
};

/**
 * Set Calendar For Events
 * Set a calendar to be used for events.
 * This will unset any other calendar previously set for events.
 */
export const setCalendarForEvents = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SetCalendarForEventsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SetCalendarForEventsResponse,
    SetCalendarForEventsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/set-for-events',
  });
};

/**
 * Get Events Calendar
 * Get the calendar currently set for events.
 */
export const getEventsCalendar = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetEventsCalendarResponse,
    GetEventsCalendarError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events-calendar',
  });
};

/**
 * Get Schedules
 * Get all schedules for the current user in an organisation.
 */
export const getSchedules = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSchedulesResponse,
    GetSchedulesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule',
  });
};

/**
 * Create Schedule
 * Create a new schedule.
 */
export const createSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateScheduleResponse,
    CreateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule',
  });
};

/**
 * Get Default Schedule
 * Get the default schedule.
 */
export const getDefaultSchedule = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDefaultScheduleResponse,
    GetDefaultScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/default',
  });
};

/**
 * Check Schedule Overlaps
 * Check if a schedule configuration has overlapping time intervals.
 */
export const checkScheduleOverlaps = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CheckScheduleOverlapsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CheckScheduleOverlapsResponse,
    CheckScheduleOverlapsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/check-overlaps',
  });
};

/**
 * Get Schedule
 * Get a specific schedule.
 */
export const getSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetScheduleResponse,
    GetScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/{schedule_id}',
  });
};

/**
 * Update Schedule
 * Update a schedule.
 */
export const updateSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateScheduleResponse,
    UpdateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/{schedule_id}',
  });
};

/**
 * Delete Schedule
 * Delete a schedule.
 */
export const deleteSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<DeleteScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteScheduleResponse,
    DeleteScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/{schedule_id}',
  });
};

/**
 * Set Default Schedule
 * Set a schedule as default.
 */
export const setDefaultSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SetDefaultScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SetDefaultScheduleResponse,
    SetDefaultScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/{schedule_id}/set-default',
  });
};

/**
 * Duplicate Schedule
 */
export const duplicateSchedule = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<DuplicateScheduleData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    DuplicateScheduleResponse,
    DuplicateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/schedule/schedule/{schedule_id}/duplicate',
  });
};

/**
 * Sync Events
 */
export const syncEventsForCalendar = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SyncEventsForCalendarData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SyncEventsForCalendarResponse,
    SyncEventsForCalendarError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/sync/{calendar_id}',
  });
};

/**
 * Create Event Type
 * Create a new event type.
 */
export const createEventType = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateEventTypeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateEventTypeResponse,
    CreateEventTypeError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/types',
  });
};

/**
 * Get Event Types
 * Get all event types for the current user.
 */
export const getEventTypes = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<GetEventTypesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetEventTypesResponse,
    GetEventTypesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/types',
  });
};

/**
 * Get Event Type
 * Get an event type by ID.
 */
export const getEventTypeById = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetEventTypeByIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetEventTypeByIdResponse,
    GetEventTypeByIdError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/types/{event_type_id}',
  });
};

/**
 * Update Event Type
 * Update an event type.
 */
export const updateEventType = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateEventTypeData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateEventTypeResponse,
    UpdateEventTypeError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/types/{event_type_id}',
  });
};

/**
 * Delete Event Type
 * Delete an event type.
 */
export const deleteEventType = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<DeleteEventTypeData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteEventTypeResponse,
    DeleteEventTypeError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/types/{event_type_id}',
  });
};

/**
 * Google Calendar Webhook
 * Webhook endpoint for Google Calendar notifications.
 *
 * This endpoint receives notifications from Google Calendar when events change.
 */
export const googleCalendarWebhookV1CalendarEventsWebhooksUsernamePost = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<
    GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostResponse,
    GoogleCalendarWebhookV1CalendarEventsWebhooksUsernamePostError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/calendar/events/webhooks/{username}',
  });
};

/**
 * Get Time Slots
 * Get available time slots for a specific event type.
 */
export const getTimeSlots = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetTimeSlotsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetTimeSlotsResponse,
    GetTimeSlotsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/time-slots-and-details-for-date/{username}/{event_type_slug}',
  });
};

/**
 * Create Booking
 * Create a new booking for an event type.
 */
export const createBooking = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateBookingData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBookingResponse,
    CreateBookingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/bookings/{event_type_id}',
  });
};

/**
 * Get User Bookings
 * Get bookings for the current user with filtering options.
 *
 * Supports filtering by:
 * - Event Type
 * - Team
 * - Member
 * - Attendee Names (multiple)
 * - Attendee Emails (multiple)
 * - Date Range
 *
 * Results are paginated.
 */
export const getUserBookings = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetUserBookingsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GetUserBookingsResponse,
    GetUserBookingsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/filtered-bookings',
  });
};

/**
 * Get Booking
 * Get a booking by ID.
 */
export const getBookingById = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetBookingByIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBookingByIdResponse,
    GetBookingByIdError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/bookings/{booking_id}',
  });
};

/**
 * Cancel Booking
 * Cancel a booking.
 */
export const cancelBooking = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CancelBookingData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    CancelBookingResponse,
    CancelBookingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/bookings/{booking_id}',
  });
};

/**
 * Update Booking Status
 * Update a booking's status.
 */
export const updateBookingStatus = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateBookingStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateBookingStatusResponse,
    UpdateBookingStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/bookings/{booking_id}/status',
  });
};

/**
 * Reschedule Booking
 * Reschedule a booking to a new time.
 */
export const rescheduleBooking = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<RescheduleBookingData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    RescheduleBookingResponse,
    RescheduleBookingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/bookings/{booking_id}/reschedule',
  });
};

/**
 * Create Doctor Booking
 * Create a new booking for a patient by a doctor (authenticated user).
 *
 * This endpoint allows doctors to schedule appointments for their patients
 * without requiring patient interaction in the booking process.
 * The appointment end time is automatically calculated based on the event type duration.
 */
export const createDoctorBooking = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateDoctorBookingData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateDoctorBookingResponse,
    CreateDoctorBookingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/doctor-bookings',
  });
};

/**
 * Get Next Questionnaire Question
 * Get the next question for a booking's questionnaire.
 */
export const getNextQuestionnaireQuestion = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<GetNextQuestionnaireQuestionData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetNextQuestionnaireQuestionResponse,
    GetNextQuestionnaireQuestionError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/questionnaire/question',
  });
};

/**
 * Save Patient Questionnaire Response
 * Save a patient's response to a questionnaire question and get the next question.
 */
export const savePatientQuestionnaireResponse = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<
    SavePatientQuestionnaireResponseData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    SavePatientQuestionnaireResponseResponse,
    SavePatientQuestionnaireResponseError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/questionnaire/response',
  });
};

/**
 * Get All Questionnaire Responses
 * Get all questionnaire responses for a booking.
 */
export const getQuestionnaireResponses = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetQuestionnaireResponsesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetQuestionnaireResponsesResponse,
    GetQuestionnaireResponsesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/questionnaire/responses',
  });
};

/**
 * Get Structured Questionnaire Question
 * Get the next question with full structured medical context.
 */
export const getStructuredQuestionnaireQuestion = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<
    GetStructuredQuestionnaireQuestionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetStructuredQuestionnaireQuestionResponse,
    GetStructuredQuestionnaireQuestionError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/questionnaire/structured-question',
  });
};

/**
 * Upload Appointment Recording
 * Upload an audio recording file for an appointment.
 */
export const uploadAppointmentRecording = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<UploadAppointmentRecordingData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    UploadAppointmentRecordingResponse,
    UploadAppointmentRecordingError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/v1/bookings/appointments/{booking_id}/recordings/upload',
  });
};

/**
 * Get Appointment Recordings
 * Get all recordings for an appointment.
 */
export const getAppointmentRecordings = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetAppointmentRecordingsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAppointmentRecordingsResponse,
    GetAppointmentRecordingsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/recordings',
  });
};

/**
 * Get Appointment Recording
 * Get a specific recording for an appointment.
 */
export const getAppointmentRecording = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetAppointmentRecordingData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAppointmentRecordingResponse,
    GetAppointmentRecordingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/recordings/{recording_id}',
  });
};

/**
 * Update Appointment Timing
 * Update the actual start and/or end time of an appointment.
 */
export const updateAppointmentTiming = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateAppointmentTimingData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdateAppointmentTimingResponse,
    UpdateAppointmentTimingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/timing',
  });
};

/**
 * Get Recording Status
 * Poll the status of a specific recording for an appointment.
 *
 * This endpoint is designed for quick polling to check the processing status
 * of a recording without fetching all recording data.
 */
export const getRecordingStatus = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetRecordingStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetRecordingStatusResponse,
    GetRecordingStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/recordings/{recording_id}/status',
  });
};

/**
 * Get Detailed Booking
 * Get comprehensive information about a booking, including all related data.
 *
 * This endpoint returns a booking with all its associated data:
 * - Basic booking information
 * - Recordings
 * - SOAP Notes
 * - Patient Visit details
 * - Medications prescribed during the visit
 * - AI-generated structured output
 */
export const getDetailedBooking = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetDetailedBookingData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDetailedBookingResponse,
    GetDetailedBookingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/bookings/appointments/{booking_id}/detailed',
  });
};

/**
 * Get Billing Plans
 * Get all active billing plans.
 */
export const getBillingPlans = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBillingPlansResponse,
    GetBillingPlansError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/billing/billing/plans',
  });
};

/**
 * Get Billing Plan
 * Get billing plan by ID.
 */
export const getBillingPlan = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetBillingPlanData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBillingPlanResponse,
    GetBillingPlanError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/billing/billing/plans/{plan_id}',
  });
};

/**
 * Get Organisation Plan
 * Get organisation billing plan.
 */
export const getOrganisationBillingPlan = <
  ThrowOnError extends boolean = false
>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganisationBillingPlanResponse,
    GetOrganisationBillingPlanError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/billing/billing/organisation',
  });
};

/**
 * Upgrade Plan
 * Upgrade to a new billing plan.
 *
 * This will:
 * - Check for valid payment methods
 * - Terminate current subscription
 * - Create new subscription
 * - Create user events for all organization members
 */
export const upgradeBillingPlan = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpgradeBillingPlanData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    UpgradeBillingPlanResponse,
    UpgradeBillingPlanError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/billing/billing/upgrade',
  });
};

/**
 * Create Patient
 * Create a new patient.
 */
export const createPatient = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientResponse,
    CreatePatientError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients',
  });
};

/**
 * Get Patients
 * Get all patients for the current organisation.
 */
export const getPatients = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientsResponse,
    GetPatientsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients',
  });
};

/**
 * Get Patient
 * Get a patient by ID.
 */
export const getPatient = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientResponse,
    GetPatientError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}',
  });
};

/**
 * Update Patient
 * Update a patient by ID.
 */
export const updatePatient = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdatePatientData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdatePatientResponse,
    UpdatePatientError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}',
  });
};

/**
 * Delete Patient
 * Delete a patient by ID.
 */
export const deletePatient = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<DeletePatientData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeletePatientResponse,
    DeletePatientError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}',
  });
};

/**
 * Create Patient Profile
 * Create a profile for a patient.
 */
export const createPatientProfile = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientProfileData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientProfileResponse,
    CreatePatientProfileError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/profile',
  });
};

/**
 * Update Patient Profile
 * Update a patient's profile.
 */
export const updatePatientProfile = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdatePatientProfileData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdatePatientProfileResponse,
    UpdatePatientProfileError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/profile',
  });
};

/**
 * Create Patient Vital
 * Create a vital record for a patient.
 */
export const createPatientVital = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientVitalData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientVitalResponse,
    CreatePatientVitalError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/vitals',
  });
};

/**
 * Get Patient Vitals
 * Get all vital records for a patient.
 */
export const getPatientVitals = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientVitalsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientVitalsResponse,
    GetPatientVitalsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/vitals',
  });
};

/**
 * Create Patient Medication
 * Create a medication record for a patient.
 */
export const createPatientMedication = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientMedicationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientMedicationResponse,
    CreatePatientMedicationError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/medications',
  });
};

/**
 * Get Patient Medications
 * Get all medication records for a patient.
 */
export const getPatientMedications = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientMedicationsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientMedicationsResponse,
    GetPatientMedicationsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/medications',
  });
};

/**
 * Create Patient Allergy
 * Create an allergy record for a patient.
 */
export const createPatientAllergy = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientAllergyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientAllergyResponse,
    CreatePatientAllergyError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/allergies',
  });
};

/**
 * Get Patient Allergies
 * Get all allergy records for a patient.
 */
export const getPatientAllergies = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientAllergiesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientAllergiesResponse,
    GetPatientAllergiesError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/allergies',
  });
};

/**
 * Create Patient Visit
 * Create a visit record for a patient.
 */
export const createPatientVisit = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePatientVisitData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePatientVisitResponse,
    CreatePatientVisitError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/visits',
  });
};

/**
 * Get Patient Visits
 * Get all visit records for a patient.
 */
export const getPatientVisits = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientVisitsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientVisitsResponse,
    GetPatientVisitsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/visits',
  });
};

/**
 * Get Patient Visit
 * Get a specific visit record for a patient.
 */
export const getPatientVisit = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientVisitData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientVisitResponse,
    GetPatientVisitError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/visits/{visit_id}',
  });
};

/**
 * Get Patients By Doctor
 * Get all patients for a specific doctor in the current organisation.
 */
export const getPatientsByDoctor = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientsByDoctorData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientsByDoctorResponse,
    GetPatientsByDoctorError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/by-doctor/{doctor_id}',
  });
};

/**
 * Get Patients Created By User
 * Get all patients created by a specific user in the current organisation.
 */
export const getPatientsCreatedByUser = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPatientsCreatedByUserData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPatientsCreatedByUserResponse,
    GetPatientsCreatedByUserError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/created-by/{user_id}',
  });
};

/**
 * Get My Patients
 * Get all patients where the current user is the primary physician.
 */
export const getMyPatients = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetMyPatientsResponse,
    GetMyPatientsError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/my-patients',
  });
};

/**
 * Verify Patient Onboarding Token
 * Verify a patient onboarding token and return the patient details.
 */
export const verifyPatientOnboardingToken = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<VerifyPatientOnboardingTokenData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    VerifyPatientOnboardingTokenResponse,
    VerifyPatientOnboardingTokenError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/onboarding/verify',
  });
};

/**
 * Submit Patient Onboarding
 * Submit a patient's onboarding form answers.
 */
export const submitPatientOnboarding = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SubmitPatientOnboardingData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SubmitPatientOnboardingResponse,
    SubmitPatientOnboardingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/onboarding/submit',
  });
};

/**
 * Send Patient Onboarding
 * Send an onboarding link to an existing patient.
 */
export const sendPatientOnboarding = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SendPatientOnboardingData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SendPatientOnboardingResponse,
    SendPatientOnboardingError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/send-onboarding',
  });
};

/**
 * Submit Patient Self Edit
 * Submit patient self-edit form.
 *
 * This endpoint allows patients to edit their own information using a token
 * sent to them. The token validates their identity and allows them to update
 * certain fields without requiring authentication.
 *
 * Note: This endpoint does not allow updating the phone number as it's used
 * for verification.
 */
export const submitPatientSelfEdit = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SubmitPatientSelfEditData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SubmitPatientSelfEditResponse,
    SubmitPatientSelfEditError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/self-edit/submit',
  });
};

/**
 * Verify Patient Self Edit Token
 * Verify a patient self-edit token and return patient information.
 *
 * This endpoint allows validating a token before displaying the self-edit form
 * to the patient. It returns the patient's current information that can be used
 * to pre-populate the form fields.
 */
export const verifyPatientSelfEditToken = <
  ThrowOnError extends boolean = false
>(
  options: OptionsLegacyParser<VerifyPatientSelfEditTokenData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    VerifyPatientSelfEditTokenResponse,
    VerifyPatientSelfEditTokenError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/self-edit/verify',
  });
};

/**
 * Send Patient Self Edit
 * Generate and send a self-edit link to a patient.
 *
 * This endpoint generates a token for a patient to edit their information
 * and sends it to them via the specified notification channel.
 */
export const sendPatientSelfEdit = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<SendPatientSelfEditData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SendPatientSelfEditResponse,
    SendPatientSelfEditError,
    ThrowOnError
  >({
    ...options,
    url: '/v1/patients/{patient_id}/send-self-edit',
  });
};
